import { useSignupState } from './useSignupState'
import { useSignupSession } from './useSignupSession'
import { useCallback } from 'react'

export const useFetchPrinterClaimStatus = () => {
  const { partialSubscription } = useSignupState()
  const { instantInkService } = useSignupSession()

  const startedWaitingTime = Date.now()

  return useCallback(async () => {
    try {
      const totalWaitingTime = startedWaitingTime
        ? ((Date.now() - Number(startedWaitingTime)) / 1000).toFixed(2)
        : undefined
      const { data } = await instantInkService.fetchPrinterClaimStatus(
        partialSubscription?.data?.id,
        totalWaitingTime
      )

      return data
    } catch (error) {
      throw {
        error: error
      }
    }
  }, [instantInkService, partialSubscription?.data?.id, startedWaitingTime])
}
